const css = `.GA7aia__avatar{background:var(--base-surfaces-default);cursor:default;box-sizing:border-box;border-style:solid;border-width:2px;border-radius:50%;flex-shrink:0;justify-content:center;align-items:center;display:inline-flex}.GA7aia__avatar.GA7aia__disabled{background-color:var(--base-surfaces-disabled);border-color:var(--base-strokes-disabled)}.GA7aia__avatar:focus-visible{outline:none}.GA7aia__avatar>span{line-height:1px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"avatar":"GA7aia__avatar","disabled":"GA7aia__disabled"};
